export const createMediaLibrary = (options, callback) => {
  return window.cloudinary.createMediaLibrary(options, callback);
};

export const openMediaLibrary = (options, callback) => {
  return window.cloudinary.openMediaLibrary(options, callback);
};
